define('components/forms',[
    'jquery'
], function($) {

    $.extend(companyInfo.decorators, {

        'form-inputs': function(e) {
            var form = $(this);

            if (this.elements.length == 1) {

                // form="" attribute NOT supported, so we need to plug it

                // Grab currently selected checkboxes, and add them to the form
                $(this).closest('.panel').find('input:checked').each(function() {
                    form.append('<input type="hidden" name="' + this.name + '" value="' + this.value + '">');
                });

                // Add click handlers for checkboxes, so they are added/removed to the form
                $.extend(companyInfo.handlers, {
                    'form-inputs-checkbox': function(e) {
                        if (this.checked) {
                            form.append('<input type="hidden" name="' + this.name + '" value="' + this.value + '">');
                        } else {
                            form.find('[name=' + this.name + '][value=' + this.value + ']').remove();
                        }
                    }
                });
            } else {

                // form="" attribute supported
                $.extend(companyInfo.handlers, {
                    'form-inputs-checkbox': function(e) {
                        // This could be removed, but no harm in keeping it (for the styleguide check)
                    }
                });
            }
        },

        'peergroup-benchmark': function(e) {
            var form = $(this);

            if (this.elements.length == 1) {

                // form="" attribute NOT supported, so we need to plug it

                // Grab currently selected checkboxes, and add them to the form
                $(this).closest('.panel').find('input:checked').each(function() {
                    var select = $(this).closest('tr').find('select');
                    var toAdd = '<input type="hidden" name="' + select.attr('name') + '" value="' + select.val() + '"><input type="hidden" name="benchmark" value="' + this.value + '">';
                    form.append(toAdd);
                    select.off('change').on('change', function() {
                        form.find('[name=' + $(this).attr('name') + ']').val($(this).val());
                    });
                });

                // Add click handlers for checkboxes, so they are added/removed to the form
                $.extend(companyInfo.handlers, {
                    'benchmark-check': function(e) {
                        var select = $(this).closest('tr').find('select');
                        if (this.checked) {
                            var toAdd = '<input type="hidden" name="' + select.attr('name') + '" value="' + select.val() + '"><input type="hidden" name="benchmark" value="' + this.value + '">';
                            form.append(toAdd);
                            select.off('change').on('change', function() {
                                form.find('[name=' + $(this).attr('name') + ']').val($(this).val());
                            });
                        } else {
                            var toRemove = form.find('[name=' + select.attr('name') + ']');
                            toRemove.next().remove();
                            toRemove.remove();
                            select.off('change');
                        }
                    }
                });
            } else {

                // form="" attribute supported
                $.extend(companyInfo.handlers, {
                    'benchmark-check': function(e) {
                        // This could be removed, but no harm in keeping it (for the styleguide check)
                    }
                });
            }
        }

    });

    $.extend(companyInfo.handlers, {

        'toggle-checkboxes': function(e) {
            var index = $(this).parent().index();
            var checked = this.checked;
            
            $(this).closest('table').find('tbody tr, thead tr, tfoot tr').find('td:eq(' + index + ') input').prop('checked', checked);

            if (this.checked && this.getAttribute('data-confirm')!== null && !confirm(this.getAttribute('data-confirm'))) {
                $('[name=checkboxAll]').prop('checked', false);
            }
        }

    });

    $.extend(companyInfo.handlers, {

        'toggle-child-checkboxes': function(e) {
            var checked = this.checked;
            var checkboxGroup = this.getAttribute('data-checkbox-group');
            $("input[data-checkbox-group|='" + checkboxGroup + "']").prop( "checked", checked ).trigger("change");
        }

    });

});
